import AREAS from './areas'

export default class CreateNotificacionDto {
  constructor(data = {}) {
    this.fk_idPersonalResponsable = data.responsable ?? null
    this.fk_idPersonalAfectado = data.afectado ?? null
    this.título = data.titulo ?? ''
    this.mensaje = data.mensaje ?? ''
    this.prioridad = data.prioridad ?? ''
    this.categoría = data.categoria ?? ''
    this.armeria = data.area === AREAS.ARMERIA ? 1 : 0
    this.equipamiento = data.equipamiento ? 1 : 0
    this.ifcsp = data.area === AREAS.IFCSP ? 1 : 0
    this.desarrollo_policial = data.area === AREAS.DESARROLLO_POLICIAL ? 1 : 0
    this.enlace_c3 = data.area === AREAS.ENLACE_C3 ? 1 : 0
    this.recursos_humanos = data.area === AREAS.RECURSOS_HUMANOS ? 1 : 0
    this.registro_personal = data.registroPersonal ? 1 : 0
    this.enlace_comisaria = data.enlaceComisaria ? 1 : 0
    this.ejecutivo = data.ejecutivo ? 1 : 0
  }

  toPrimitives() {
    return { ...this }
  }
}
